import React from 'react'

import { HelpDialog } from '../modals/help'
import ChartLayout from '../models/chart_layout'
import { IdeasDropdown } from './header/ideas_dropdown'

interface NoticeProps {
  layoutModel: ChartLayout
  handleAddNote: () => void
}

export default function Notice(props: NoticeProps) {
  return (
    <>
      <div className="flex items-stretch">
        <IdeasDropdown
          model={props.layoutModel}
          rounding="none"
          theme="outline"
          dropdownButtonClassName="btn min-h-[30px]"
        />
        {window.FinvizSettings.hasUserPremium && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href="#"
            className="tab-link"
            onClick={(e) => {
              e.preventDefault()
              props.handleAddNote()
            }}
            data-testid="charts-notice-ideas-add-note-btn"
          >
            + Add a note
          </a>
        )}
      </div>
      <div>
        <HelpDialog hasNewQuoteMenu={window.FinvizSettings.hasUserPremium} />
      </div>
    </>
  )
}
